import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import ClientManagement from './ClientManagement';
import { MobileClientManagement } from './mobile';

/**
 * Responsive wrapper for ClientManagement that renders the appropriate version
 * based on the device screen size
 */
const ResponsiveClientManagement = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Render the mobile version on small screens, desktop version otherwise
  return isMobile ? <MobileClientManagement /> : <ClientManagement />;
};

export default ResponsiveClientManagement; 